/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/two_factor';
import '../common/countries';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "employees": {
        "nested": {
          "EmployeePermissionFlags": {
            "values": {
              "EMPLOYEE_ACCESS_SALES_HISTORY": 0,
              "EMPLOYEE_APPLY_RESTRICTED_DISCOUNTS": 1,
              "EMPLOYEE_CHANGE_REGISTER_SETTINGS": 2,
              "EMPLOYEE_EDIT_ITEMS": 3,
              "EMPLOYEE_ISSUE_REFUNDS": 4,
              "EMPLOYEE_OPEN_CASH_DRAWER_OUTSIDE_SALE": 5,
              "EMPLOYEE_VIEW_CASH_DRAWER_REPORTS": 6,
              "EMPLOYEE_VIEW_SUMMARIES_REPORTS": 7,
              "EMPLOYEE_VOID_OPEN_TICKETS": 29,
              "EMPLOYEE_USE_INSTANT_DEPOSIT": 32,
              "EMPLOYEE_CANCEL_BUYER_FLOW": 45,
              "EMPLOYEE_MANAGE_ALL_OPEN_TICKETS": 47,
              "EMPLOYEE_SETTLE_ALL_PAYMENTS_AWAITING_TIP": 48,
              "EMPLOYEE_VIEW_EXPECTED_IN_DRAWER": 52,
              "EMPLOYEE_TOGGLE_OFFLINE_MODE": 55,
              "EMPLOYEE_USE_CARD_ON_FILE": 56,
              "EMPLOYEE_MANAGE_CUSTOMERS": 58,
              "EMPLOYEE_CANCEL_TRANSACTION": 60,
              "EMPLOYEE_ADJUST_PUNCHES": 62,
              "EMPLOYEE_MANAGE_EMPLOYEES": 64,
              "EMPLOYEE_EDIT_TAXES_IN_SALE": 66,
              "EMPLOYEE_USE_INVOICES_APPLET": 69,
              "EMPLOYEE_EDIT_SURCHARGES_IN_SALE": 72,
              "EMPLOYEE_CREATE_BANK_ACCOUNT": 74,
              "EMPLOYEE_MANAGE_SERVICE_SETTINGS": 79,
              "EMPLOYEE_RUN_CLOSE_OF_DAY": 84,
              "EMPLOYEE_VIEW_DEPOSITS_AND_SQUARE_CARD": 86,
              "EMPLOYEE_VIEW_SQUARE_CARD_MANAGEMENT": 89,
              "EMPLOYEE_REOPEN_CHECKS": 94,
              "EMPLOYEE_MANAGE_CAPITAL": 97,
              "EMPLOYEE_MANAGE_DISPUTES": 100,
              "EMPLOYEE_MANAGE_ORDERS": 102,
              "EMPLOYEE_VIEW_SALES_REPORTS": 106,
              "EMPLOYEE_VIEW_DETAILED_SALES_REPORTS": 108,
              "EMPLOYEE_VIEW_LOYALTY_REPORTS": 110,
              "EMPLOYEE_MANAGE_DEVICE_SECURITY": 112,
              "EMPLOYEE_MANAGE_RECEIPT_INFORMATION": 113,
              "EMPLOYEE_MANAGE_TIME_TRACKING_SETTINGS": 115,
              "EMPLOYEE_MANAGE_HARDWARE_SETTINGS": 116,
              "EMPLOYEE_MANAGE_CHECKOUT_SETTINGS": 118,
              "EMPLOYEE_MANAGE_ORDER_SETTINGS": 120,
              "EMPLOYEE_VIEW_BANK_ACCOUNT_INFORMATION": 122,
              "EMPLOYEE_MANAGE_BALANCE_SETTINGS": 124,
              "EMPLOYEE_MANAGE_DEVICES": 126,
              "EMPLOYEE_APP_SIGN_OUT": 128,
              "EMPLOYEE_CUSTOMIZE_DIRECTORY_OPTIONS": 129,
              "EMPLOYEE_END_TIMECARD_BREAK_EARLY": 140,
              "MOBILE_EMPLOYEE_ACCESS_SALES_HISTORY": 34,
              "MOBILE_EMPLOYEE_APPLY_RESTRICTED_DISCOUNTS": 35,
              "MOBILE_EMPLOYEE_CHANGE_REGISTER_SETTINGS": 36,
              "MOBILE_EMPLOYEE_EDIT_ITEMS": 37,
              "MOBILE_EMPLOYEE_ISSUE_REFUNDS": 38,
              "MOBILE_EMPLOYEE_OPEN_CASH_DRAWER_OUTSIDE_SALE": 39,
              "MOBILE_EMPLOYEE_VIEW_CASH_DRAWER_REPORTS": 40,
              "MOBILE_EMPLOYEE_VIEW_SUMMARIES_REPORTS": 41,
              "MOBILE_EMPLOYEE_VOID_OPEN_TICKETS": 42,
              "MOBILE_EMPLOYEE_USE_INSTANT_DEPOSIT": 43,
              "MOBILE_EMPLOYEE_CANCEL_BUYER_FLOW": 46,
              "MOBILE_EMPLOYEE_MANAGE_ALL_OPEN_TICKETS": 49,
              "MOBILE_EMPLOYEE_SETTLE_ALL_PAYMENTS_AWAITING_TIP": 50,
              "MOBILE_EMPLOYEE_VIEW_EXPECTED_IN_DRAWER": 53,
              "MOBILE_EMPLOYEE_TOGGLE_OFFLINE_MODE": 54,
              "MOBILE_EMPLOYEE_USE_CARD_ON_FILE": 57,
              "MOBILE_EMPLOYEE_MANAGE_CUSTOMERS": 59,
              "MOBILE_EMPLOYEE_CANCEL_TRANSACTION": 61,
              "MOBILE_EMPLOYEE_ADJUST_PUNCHES": 63,
              "MOBILE_EMPLOYEE_MANAGE_EMPLOYEES": 65,
              "MOBILE_EMPLOYEE_EDIT_TAXES_IN_SALE": 67,
              "MOBILE_EMPLOYEE_USE_INVOICES_APPLET": 70,
              "MOBILE_EMPLOYEE_EDIT_SURCHARGES_IN_SALE": 73,
              "MOBILE_EMPLOYEE_CREATE_BANK_ACCOUNT": 75,
              "MOBILE_EMPLOYEE_ACCESS_ALL_SALES_HISTORY": 78,
              "MOBILE_EMPLOYEE_MANAGE_SERVICE_SETTINGS": 80,
              "MOBILE_EMPLOYEE_RUN_CLOSE_OF_DAY": 85,
              "MOBILE_EMPLOYEE_VIEW_DEPOSITS_AND_SQUARE_CARD": 87,
              "MOBILE_EMPLOYEE_VIEW_SQUARE_CARD_MANAGEMENT": 90,
              "MOBILE_EMPLOYEE_REOPEN_CHECKS": 95,
              "MOBILE_EMPLOYEE_MANAGE_CAPITAL": 96,
              "MOBILE_EMPLOYEE_MANAGE_INVOICE_NOTIFICATIONS": 99,
              "MOBILE_EMPLOYEE_MANAGE_DISPUTES": 101,
              "MOBILE_EMPLOYEE_MANAGE_ORDERS": 104,
              "MOBILE_EMPLOYEE_VIEW_SALES_REPORTS": 107,
              "MOBILE_EMPLOYEE_VIEW_DETAILED_SALES_REPORTS": 109,
              "MOBILE_EMPLOYEE_VIEW_LOYALTY_REPORTS": 111,
              "MOBILE_EMPLOYEE_MANAGE_RECEIPT_INFORMATION": 114,
              "MOBILE_EMPLOYEE_MANAGE_HARDWARE_SETTINGS": 117,
              "MOBILE_EMPLOYEE_MANAGE_CHECKOUT_SETTINGS": 119,
              "MOBILE_EMPLOYEE_MANAGE_ORDER_SETTINGS": 121,
              "MOBILE_EMPLOYEE_VIEW_BANK_ACCOUNT_INFORMATION": 123,
              "MOBILE_EMPLOYEE_MANAGE_BALANCE_SETTINGS": 125,
              "MOBILE_EMPLOYEE_MANAGE_DEVICES": 127,
              "MOBILE_EMPLOYEE_CUSTOMIZE_DIRECTORY_OPTIONS": 130,
              "MOBILE_EMPLOYEE_MANAGE_TIME_TRACKING_SETTINGS": 137,
              "MOBILE_EMPLOYEE_END_TIMECARD_BREAK_EARLY": 141,
              "MOBILE_EMPLOYEE_STORE_AND_FORWARD_PAYMENTS": 44,
              "EMPLOYEE_DASHBOARD_ISSUE_REFUNDS": 8,
              "EMPLOYEE_DASHBOARD_VIEW_REPORTS_AND_TRANSACTIONS": 9,
              "EMPLOYEE_DASHBOARD_MANAGE_ITEMS": 10,
              "EMPLOYEE_DASHBOARD_MANAGE_EMPLOYEES": 11,
              "EMPLOYEE_DASHBOARD_GRANT_EMPLOYEES_REGISTER_ACCESS": 12,
              "EMPLOYEE_DASHBOARD_GRANT_EMPLOYEES_DASHBOARD_ACCESS": 13,
              "EMPLOYEE_DASHBOARD_MANAGE_TIMECARDS": 14,
              "EMPLOYEE_DASHBOARD_MANAGE_EMPLOYEE_ROLES": 71,
              "EMPLOYEE_DASHBOARD_VIEW_CUSTOMERS": 15,
              "EMPLOYEE_DASHBOARD_MANAGE_CUSTOMER_IMPORT_EXPORT_AND_CUSTOM_FIELDS": 82,
              "EMPLOYEE_DASHBOARD_MANAGE_CUSTOMER_CAMPAIGNS": 16,
              "EMPLOYEE_DASHBOARD_VIEW_FEEDBACK_AND_REPLY": 83,
              "EMPLOYEE_DASHBOARD_MANAGE_LOYALTY_SUSPICIOUS_ACTIVITY": 105,
              "EMPLOYEE_DASHBOARD_ADJUST_PUNCHES": 145,
              "EMPLOYEE_DASHBOARD_VIEW_LOYALTY_REPORTS": 146,
              "EMPLOYEE_DASHBOARD_MANAGE_BANK_ACCOUNTS": 17,
              "EMPLOYEE_DASHBOARD_MANAGE_BUSINESS_PROFILE": 18,
              "EMPLOYEE_DASHBOARD_MANAGE_DEVICES": 19,
              "EMPLOYEE_DASHBOARD_MANAGE_LOCATIONS": 20,
              "EMPLOYEE_DASHBOARD_MANAGE_LOCATION_ITEM_LIBRARIES": 21,
              "EMPLOYEE_DASHBOARD_MANAGE_SUBSCRIPTIONS": 22,
              "EMPLOYEE_DASHBOARD_MANAGE_CAPITAL": 23,
              "EMPLOYEE_DASHBOARD_MANAGE_INVOICES": 33,
              "EMPLOYEE_DASHBOARD_MANAGE_INSTRUMENTS_ON_FILE": 51,
              "EMPLOYEE_DASHBOARD_MANAGE_SERVICE_SETTINGS": 81,
              "EMPLOYEE_DASHBOARD_VIEW_DEPOSITS_AND_SQUARE_CARD": 88,
              "EMPLOYEE_DASHBOARD_VIEW_SQUARE_CARD_MANAGEMENT": 91,
              "EMPLOYEE_DASHBOARD_MANAGE_CASH_DRAWERS": 92,
              "EMPLOYEE_DASHBOARD_VIEW_EXPECTED_IN_DRAWER": 93,
              "EMPLOYEE_DASHBOARD_MANAGE_RISK_EVALUATION_SETTINGS": 98,
              "EMPLOYEE_DASHBOARD_MANAGE_ORDERS": 103,
              "EMPLOYEE_DASHBOARD_VIEW_SALES_REPORTS": 131,
              "EMPLOYEE_DASHBOARD_VIEW_CASH_DRAWER_REPORTS": 132,
              "EMPLOYEE_DASHBOARD_MANAGE_DISPUTES": 133,
              "EMPLOYEE_DASHBOARD_VIEW_ACTIVITY_REPORTS": 134,
              "EMPLOYEE_DASHBOARD_VIEW_TRANSACTIONS": 135,
              "EMPLOYEE_DASHBOARD_MANAGE_DEVICE_SECURITY": 246,
              "EMPLOYEE_DASHBOARD_MANAGE_CHECKOUT_SETTINGS": 247,
              "EMPLOYEE_DASHBOARD_MANAGE_TIME_TRACKING_SETTINGS": 248,
              "EMPLOYEE_DASHBOARD_ACCESS_TERMINAL": 68,
              "EMPLOYEE_MANAGE_ALL_CALENDARS": 76,
              "EMPLOYEE_MANAGE_APPOINTMENTS_BUSINESS_PROFILE": 77,
              "EMPLOYEE_ACCESS_DASHBOARD": 24,
              "EMPLOYEE_ACCESS_REGISTER": 25,
              "EMPLOYEE_ACCESS_PAYROLL": 26,
              "EMPLOYEE_ACCESS_APPOINTMENTS": 27,
              "EMPLOYEE_ACCESS_TRACK_TIME": 28,
              "EMPLOYEE_GRANT_CONNECT_API_ACCESS": 30,
              "EMPLOYEE_ACCESS_MOBILE_REGISTER": 31,
              "TAKE_PAYMENT": 136,
              "VIEW_INVENTORY_REPORTS": 138,
              "END_TIMECARD_BREAK_EARLY": 139,
              "ACCESS_NOTIFICATION_CENTER": 142,
              "MANAGE_SCHEDULES": 143,
              "MANAGE_SCHEDULE_AVAILABILITY": 151,
              "MANAGE_SCHEDULE_REQUESTS": 193,
              "MANAGE_TIMECARD_ENFORCEMENT_SETTINGS": 194,
              "MANAGE_CONTRACTS": 144,
              "VIEW_LOYALTY_ACCOUNTS": 147,
              "VIEW_LOYALTY_SETTINGS": 148,
              "UPDATE_LOYALTY_SETTINGS": 149,
              "MANAGE_LOYALTY_PROMOTIONS": 150,
              "CUSTOMER_READ": 152,
              "CUSTOMER_DIRECTORY_ACCESS": 153,
              "CUSTOMER_INSIGHTS_ACCESS": 154,
              "CUSTOMER_FEEDBACK_ACCESS": 188,
              "CUSTOMER_CONTACT_INFO_READ": 155,
              "CUSTOMER_CREATE": 156,
              "CUSTOMER_IMPORT": 157,
              "CUSTOMER_EXPORT": 158,
              "CUSTOMER_UPDATE": 159,
              "CUSTOMER_DELETE": 160,
              "CUSTOMER_MERGE": 161,
              "CUSTOMER_BULK": 162,
              "CUSTOMER_GROUP_READ": 163,
              "CUSTOMER_GROUP_CREATE": 164,
              "CUSTOMER_GROUP_UPDATE": 165,
              "CUSTOMER_GROUP_DELETE": 166,
              "CUSTOMER_GROUP_MEMBER_ADD_AND_REMOVE": 167,
              "CUSTOMER_CARDONFILE_READ": 168,
              "CUSTOMER_CARDONFILE_CREATE": 169,
              "CUSTOMER_CARDONFILE_DELETE": 170,
              "CUSTOMER_CUSTOMFIELD_DEFINITION_READ": 172,
              "CUSTOMER_CUSTOMFIELD_DEFINITION_CREATE": 173,
              "CUSTOMER_CUSTOMFIELD_DEFINITION_UPDATE": 174,
              "CUSTOMER_CUSTOMFIELD_DEFINITION_DELETE": 175,
              "CUSTOMER_ATTACHMENT_READ": 176,
              "CUSTOMER_ATTACHMENT_CREATE": 177,
              "CUSTOMER_ATTACHMENT_UPDATE": 178,
              "CUSTOMER_ATTACHMENT_DELETE": 179,
              "CUSTOMER_NOTE_READ": 180,
              "CUSTOMER_NOTE_CREATE": 181,
              "CUSTOMER_NOTE_UPDATE": 182,
              "CUSTOMER_NOTE_DELETE": 183,
              "CUSTOMER_MESSAGE_CREATE": 184,
              "CUSTOMER_FILTER_READ": 185,
              "CUSTOMER_FILTER_WRITE": 186,
              "ACCESS_ONLINE_STORE": 171,
              "MANAGE_SUBSCRIPTIONS_VIA_POS": 187,
              "REFERRALS_AND_REWARDS_READ": 189,
              "REFERRALS_AND_REWARDS_WRITE": 190,
              "MANAGE_BUYER_SUBSCRIPTIONS": 191,
              "ACCESS_MESSENGER": 192,
              "MANAGE_SUBSCRIPTIONS": 195,
              "MANAGE_COMMISSION_SETTINGS": 196,
              "MANAGE_TIMECARD_EDIT_REQUESTS": 197,
              "MANAGE_CUSTOMER_CAMPAIGNS": 198,
              "MANAGE_SALES_TAX": 199,
              "MANAGE_TIP_DISTRIBUTION_SETTINGS": 200,
              "DEVELOPER_PROFILE_READ": 201,
              "DEVELOPER_PROFILE_WRITE": 202,
              "DEVELOPER_COLLABORATOR_PERMISSIONS_READ": 203,
              "DEVELOPER_COLLABORATOR_PERMISSIONS_WRITE": 204,
              "DEVELOPER_SANDBOX_ACCOUNT_READ": 205,
              "DEVELOPER_SANDBOX_ACCOUNT_WRITE": 206,
              "DEVELOPER_APPLICATION_READ": 207,
              "DEVELOPER_APPLICATION_WRITE": 208,
              "DEVELOPER_APPLICATION_CREDENTIALS_READ": 209,
              "DEVELOPER_APPLICATION_CREDENTIALS_WRITE": 210,
              "DEVELOPER_APPLICATION_OAUTH_READ": 211,
              "DEVELOPER_APPLICATION_OAUTH_WRITE": 212,
              "DEVELOPER_APPLICATION_WEBHOOKS_READ": 213,
              "DEVELOPER_APPLICATION_WEBHOOKS_WRITE": 214,
              "DEVELOPER_APPLICATION_READER_SDK_READ": 215,
              "DEVELOPER_APPLICATION_READER_SDK_WRITE": 216,
              "DEVELOPER_APPLICATION_POINT_OF_SALE_API_READ": 217,
              "DEVELOPER_APPLICATION_POINT_OF_SALE_API_WRITE": 218,
              "DEVELOPER_APPLICATION_APPLE_PAY_READ": 219,
              "DEVELOPER_APPLICATION_APPLE_PAY_WRITE": 220,
              "DEVELOPER_APPLICATION_REVIEWS_READ": 221,
              "DEVELOPER_APPLICATION_REVIEWS_WRITE": 222,
              "DEVELOPER_APPLICATION_SUBMISSIONS_READ": 223,
              "DEVELOPER_APPLICATION_SUBMISSIONS_WRITE": 224,
              "CUSTOMIZE_NAV_BAR": 225,
              "MANAGE_INVOICES_PROJECTS": 226,
              "MANAGE_SERVICE_CHARGES": 227,
              "RST_POS_MENU_READ": 228,
              "RST_POS_MENU_WRITE": 229,
              "USE_CUSTOM_AMOUNT": 230,
              "MANAGE_CUSTOMER_BALANCES": 231,
              "INVENTORY_MANAGE_CYCLE_COUNT": 232,
              "INVENTORY_CONTRIBUTE_FULL_COUNT": 233,
              "INVENTORY_MANAGE_FULL_COUNT": 234,
              "INVENTORY_COUNTING_UNIT_COST_READ": 235,
              "MANAGE_REFERRALS_AND_REWARDS": 236,
              "CUSTOMER_PAYMENTONFILE_READ": 237,
              "CUSTOMER_PAYMENTONFILE_CREATE": 238,
              "CUSTOMER_PAYMENTONFILE_DELETE": 239,
              "HOUSE_ACCOUNTS_READ": 240,
              "HOUSE_ACCOUNTS_WRITE": 241,
              "MANAGE_ONLINE_CHECKOUT": 242,
              "MANAGE_FULFILLMENT_PREFERENCES": 243,
              "SEE_APPT_PERFORMANCE_REPORTS": 244,
              "SEE_APPT_PERFORMANCE_REPORTS_PERSONAL": 245,
              "MANAGE_SHARED_DEVICE_PROFILES_V2": 249,
              "MANAGE_SQUARE_CREDIT_CARD": 250,
              "MANAGE_ANNOUNCEMENTS": 251,
              "SEND_ANNOUNCEMENTS": 252,
              "VIEW_ALL_ANNOUNCEMENTS": 253,
              "SEND_ANNOUNCEMENTS_AS_ALIAS": 254,
              "CREATE_NEW_CONVERSATIONS": 255,
              "MESSAGE_ALL_TEAM_MEMBERS": 256,
              "MANAGE_CONVERSATIONS": 257,
              "ADD_OR_REMOVE_TEAM_MEMBERS_FROM_CONVERSATIONS": 258,
              "RENAME_CONVERSATIONS": 259,
              "CLEAR_CONVERSATION_HISTORY": 260,
              "DELETE_CONVERSATIONS": 261,
              "MODERATE_CONTENT_AND_CONVERSATIONS": 262,
              "DELETE_CONVERSATION_MESSAGES": 263,
              "SUSPEND_TEAM_MEMBERS": 264,
              "VIEW_REPORTED_MESSAGES": 265,
              "VIEW_ALL_PUBLIC_CONVERSATIONS": 266,
              "VIEW_DIRECT_MESSAGES": 267,
              "MANAGE_TEAM_FILES": 268,
              "ADD_TEAM_FILES": 269,
              "MODIFY_TEAM_FILES": 270,
              "VIEW_ALL_TEAM_FILES": 271,
              "MANAGE_TEAM_RESOURCES": 272,
              "MANAGE_TEAM_TASKS": 273,
              "CAN_VIEW_ALL_TASKS": 274,
              "EDIT_TASK_TEMPLATES": 275,
              "MANAGE_TEAM_COMMUNICATION_SETTINGS": 276,
              "MANAGE_TEAM_GROUPS": 277,
              "REMOVE_SELF_FROM_TEAM_GROUP": 278,
              "CREATE_TEAM_TASKS": 279,
              "DEVELOPER_APPLICATION_EVENTS_READ": 280,
              "DEVELOPER_APPLICATION_EVENTS_WRITE": 281,
              "BNPL_SHOP_DIRECTORY_ENROLLMENT_READ": 282,
              "BNPL_SHOP_DIRECTORY_ENROLLMENT_WRITE": 283,
              "RELEASE_MANAGER_ACCESS": 284,
              "VIEW_TEAM_MEMBER_FILES": 285,
              "MANAGE_TEAM_MEMBER_FILES": 286,
              "HR_MANAGER_MANAGE": 287,
              "ALLOW_EXIT_FROM_BUYER_FACING_SCREEN": 288,
              "APPOINTMENTS_SERVICE_COST_OVERRIDE_WRITE": 289,
              "ALLOW_START_CASH_REPORT": 290,
              "ALLOW_UPDATE_BALANCE": 291,
              "ALLOW_UPDATE_CASH_IN_CASH_OUT": 292,
              "ALLOW_END_CASH_REPORT": 293,
              "MANAGE_TEAM_MEMBER_ONBOARDING": 294,
              "SALES_REPORTS_EMAIL_READ": 295,
              "ALLOW_VIEW_WAGE_INFORMATION": 296,
              "INVENTORY_CONTRIBUTE_CYCLE_COUNT": 297,
              "POS_MODE_WRITE": 298,
              "DEVICE_POS_MODE_WRITE": 299,
              "UNLINKED_REFUNDS_WRITE": 300,
              "ISSUE_UNLINKED_REFUNDS": 301,
              "API_LOGS_READ": 302,
              "VIEW_DISPUTES": 303,
              "RESPOND_TO_DISPUTES": 304,
              "DEVELOPER_APPLICATION_APP_SIGNATURES_READ": 305,
              "DEVELOPER_APPLICATION_APP_SIGNATURES_WRITE": 306,
              "MANAGE_INVENTORY": 307,
              "MANAGE_ADVANCED_SALES_REPORT_FILTERS": 308
            }
          },
          "AccessBlocker": {
            "values": {
              "DO_NOT_USE": 0,
              "EMPLOYEE_MANAGEMENT_SUBSCRIPTION": 1,
              "EMPLOYEE_MANAGEMENT_SUBSCRIPTION_PAUSED": 2
            }
          },
          "Employment": {
            "fields": {
              "employmentToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "merchantToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "permissions": {
                "type": "bytes",
                "id": 3,
                "rule": "optional"
              },
              "debugPermissions": {
                "type": "squareup.employees.EmployeePermissionFlags",
                "id": 9,
                "rule": "repeated"
              },
              "isOwner": {
                "type": "bool",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "isSandbox": {
                "type": "bool",
                "id": 18,
                "rule": "optional"
              },
              "isAccountOwner": {
                "type": "bool",
                "id": 11,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "updatedAt": {
                "type": "int64",
                "id": 5,
                "rule": "optional"
              },
              "unitToken": {
                "type": "string",
                "id": 6,
                "rule": "repeated"
              },
              "requiresTwoFactor": {
                "type": "bool",
                "id": 7,
                "rule": "optional"
              },
              "active": {
                "type": "bool",
                "id": 8,
                "rule": "optional"
              },
              "twoFactorState": {
                "type": "squareup.common.twofactor.TwoFactorState",
                "id": 10,
                "rule": "optional"
              },
              "legacy2faSupported": {
                "type": "bool",
                "id": 12,
                "rule": "optional"
              },
              "countryCode": {
                "type": "squareup.common.countries.Country",
                "id": 13,
                "rule": "optional"
              },
              "accessBlockers": {
                "type": "squareup.employees.AccessBlocker",
                "id": 14,
                "rule": "repeated"
              },
              "isAuthorizedUser": {
                "type": "bool",
                "id": 15,
                "rule": "optional"
              },
              "canAccessAllUnits": {
                "type": "bool",
                "id": 16,
                "rule": "optional"
              },
              "hasAdditionalUnits": {
                "type": "bool",
                "id": 17,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.employees?.nested?.EmployeePermissionFlags && !$root.nested?.squareup?.nested?.employees?.nested?.AccessBlocker && !$root.nested?.squareup?.nested?.employees?.nested?.Employment) {
  $root.addJSON(jsonData);
}

/**
 * *************************************************************************************************
 * Permission flags for employees with delegated access. Each permission is binary, and stored as a
 * bitstring for compactness. The bitstring is encoded in little-endian format.
 *
 *
 *                                    --== CAVEAT EMPTOR ==--
 * This proto is used to pack a bitstring inside of web. The data is persisted in potentially
 * millions of rows.  It is then exposed as a bitstring to dozens of consuming serivces who decode
 * it independently using the order of this enum.  You should approach changing this proto with a
 * healthy dose of fear.
 *
 * Specifically, backward incompatible changes would be hard to make because all consuming services.
 * would have to be deployed.
 *
 * For the bitstring packing see:
 * https://github.com/squareup/web/blob/master/lib/bitset_field.rb
 *
 * For the bitstring unpacking see:
 * https://github.com/squareup/java/blob/master/accounts/src/main/java/com/squareup/accounts/AccountUtilities.java#L463-L463
 *
 * If you have questions, reach out to the owner team (currently #employeee-managment)
 * ************************************************************************************************
 *
 * SOURCE EmployeePermissionFlags @ squareup/employees/employees.proto at 40:1
 */
export const EmployeePermissionFlags = $root.lookupEnum('squareup.employees.EmployeePermissionFlags').values;
/**
 * Reasons for an employee's access to POS and Dashboard to be blocked
 *
 * SOURCE AccessBlocker @ squareup/employees/employees.proto at 828:1
 */
export const AccessBlocker = $root.lookupEnum('squareup.employees.AccessBlocker').values;
/**
 * Represents a person's employment at a merchant.
 *
 * SOURCE Employment @ squareup/employees/employees.proto at 842:1
 */
export const Employment = $root.lookupType('squareup.employees.Employment');
fixType(Employment);
Builder.createAndAttachToType(Employment);